import React from "react";

const AboutUs = () => {
  return (
    <section id="about-us" className="relative bg-gray-900 text-white py-20 px-6">
      <div className="container mx-auto flex flex-col md:flex-row items-center justify-center gap-12">
        
        {/* John Akintoye - Founder */}
        <div className="w-full md:w-1/3 flex flex-col items-center text-center md:text-left">
          <div className="w-52 h-52 md:w-64 md:h-64 rounded-full overflow-hidden shadow-lg border-4 border-purple-500">
            <img src={require("../assets/john.png")} alt="John Akintoye" className="w-full h-full object-cover" />
          </div>
          <h2 className="text-3xl font-bold mt-6">John Akintoye</h2>
          <p className="text-lg text-purple-400 font-semibold mb-2">Founder, Trvllr™</p>
          <p className="text-gray-300 leading-relaxed px-4 md:px-0">
            John is an experienced Travel Radiologic Technologist (BSc, Radiologic Science) and an impact enthusiast with a passion for leveraging technology to address the challenges in travel healthcare.
          </p>
        </div>

        {/* Vision and Mission Statement - Centered */}
        <div className="w-full md:w-1/3 flex flex-col items-center text-center p-6 bg-gray-800 rounded-lg shadow-lg">
          <h3 className="text-2xl font-semibold text-purple-400">Our Vision</h3>
          <p className="text-gray-300 text-lg mt-3">
            To revolutionize travel healthcare by empowering professionals with cutting-edge tools for career management, contract negotiation, and financial support.
          </p>
          <div className="w-20 h-1 bg-purple-500 my-4"></div>
          <h3 className="text-2xl font-semibold text-amber-400">Our Mission</h3>
          <p className="text-gray-300 text-lg mt-3">
            To eliminate inefficiencies in travel healthcare by providing a seamless platform where professionals can take control of their careers, finances, and well-being.
          </p>
        </div>

        {/* Esther Akintoye - Co-founder */}
        <div className="w-full md:w-1/3 flex flex-col items-center text-center md:text-left">
          <div className="w-52 h-52 md:w-64 md:h-64 rounded-full overflow-hidden shadow-lg border-4 border-amber-500">
            <img src={require("../assets/esther.png")} alt="Esther Akintoye" className="w-full h-full object-cover" />
          </div>
          <h2 className="text-3xl font-bold mt-6">Esther Akintoye</h2>
          <p className="text-lg text-amber-400 font-semibold mb-2">Co-Founder, Trvllr™</p>
          <p className="text-gray-300 leading-relaxed px-4 md:px-0">
            Esther, with an MBA in Organizational Development, ensures that Trvllr™ is not just a tool but a disruptive force in travel healthcare, driving industry-wide transformation.
          </p>
        </div>
      </div> {/* Ensure closing div here for the container */}

      {/* Decorative Accent */}
      <div className="absolute bottom-0 left-0 w-full h-16 bg-gradient-to-t from-purple-700 to-amber-500"></div>

    </section>
  );
};

export default AboutUs;
